//
// Bonus Multiview Model
// ---------------------

define(function(require, exports, module) {
    'use strict';
    var PortletModel = require('modules/portlet/portlet.model');
    var BonusMultiviewView = require('portlets/bonus-multiview/bonusmultiview.view');
    var BonusMultiviewPageView = require('portlets/bonus-multiview/bonusmultiview.page.view');

    module.exports = PortletModel.extend({

        getView: function() {
            if (this.get('config').viewType === 'pageView') {
                return this.showPageView();
            }

            return this.showMultiView();
        },

        showMultiView: function() {
            return new BonusMultiviewView({model: this});
        },

        showPageView: function() {
            return new BonusMultiviewPageView({model: this});
        }
    });
});
